import React from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import '@shopify/polaris/dist/styles.css';
import { FooterHelp, Link } from '@shopify/polaris';

const Footer = (props) => {
  let { link, name } = props;
  return (
    <FooterHelp>
      Learn more about{' '}
      <Link external={true} url={link} removeUnderline>
        {name}
      </Link>
    </FooterHelp>
  );
};

export default Footer;
